<template>
    <!-- modal-xl -->
    <b-modal
        id="certificateAddSearchModal"
        ref="certificateAddSearchModal"
        title="Add Certificate - Search"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
    >
        <div class="textcenter">
            <!-- <h5 class="mb-3">{{ this.searchForm.company_name }}</h5> -->
            <b-form>
                <b-form-group label="VAT No:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                    <b-form-input
                        disabled
                        v-model="$v.searchForm.vat_no.$model"
                        size="sm"
                        :state="validateState('vat_no')"
                        aria-describedby="input-1-live-feedback"
                        class="not-allowed-pointer"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                        {{ vatNoErrorMessage }}
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Reg No:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                    <b-form-input
                        disabled
                        v-model="$v.searchForm.company_reg.$model"
                        size="sm"
                        :state="validateState('company_reg')"
                        aria-describedby="input-2-live-feedback"
                        class="not-allowed-pointer"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                        {{ regNoErrorMessage }}
                    </b-form-invalid-feedback>
                    <!-- <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                        Either Reg No or Vat No must be filled in. Reg No must be atleast 3 Characters long
                    </b-form-invalid-feedback> -->
                </b-form-group>

                <b-form-group label="Doc Type:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                    <b-form-select
                        v-model="searchForm.document_type"
                        :options="document_type_options"
                        size="sm"
                        aria-describedby="input-2-live-feedback"
                    ></b-form-select>
                    <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                        Required
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Issue Date" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                    <!-- <b-form-datepicker v-model="value1" class="mb-2"></b-form-datepicker> -->
                    <b-form-input
                        id="date"
                        type="date"
                        size="sm"
                        v-model="searchForm.issue_date"
                        aria-describedby="input-2-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                        Required
                    </b-form-invalid-feedback>
                </b-form-group>

                <b-form-group label="Expiry Date:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                    <!-- <b-form-datepicker v-model="value2" class="mb-2"></b-form-datepicker> -->
                    <b-form-input
                        id="date"
                        value=""
                        type="date"
                        size="sm"
                        v-model="searchForm.expiry_date"
                        aria-describedby="input-2-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-2-live-feedback" class="text-left ml-2">
                        Required
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-form>
        </div>

        <div class="modal-footer d-flex justify-content-end">
            <b-button variant="primary" type="button" class="btn btn-primary" @click="search">
                Search
            </b-button>
            <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
import Swal from "sweetalert2";
import { suppliersComputed, suppliersMethods } from "../../state/helpers";
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date } from "vuelidate/lib/validators";

export default {
    data: () => ({
        formSubmit: false,
        //values for the calendar
        searchForm: {
            vat_no: "",
            // company_reg: "2010/123456/07",
            company_reg: "",
            // document_type: "Certificate",
            document_type: null,
            // issue_date: "2022-05-06",
            issue_date: "",
            // expiry_date: "2024-05-06",
            expiry_date: "",
            supplier_name: "",
            client_id: "",
        },
    }),
    validations: {
        searchForm: {
            vat_no: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!value;
                    const isCompanyRegFilled = !!this.searchForm.company_reg;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(10),
                maxLength: maxLength(10),
                numeric,
            },
            company_reg: {
                conditionalRequired(value) {
                    const isVatNoFilled = !!this.searchForm.vat_no;
                    const isCompanyRegFilled = !!value;
                    return isVatNoFilled || isCompanyRegFilled;
                },
                minLength: minLength(3),
            },
            // document_type: {
            //     required,
            // },
            // issue_date: {
            //     required,
            // },
            // expiry_date: {
            //     required,
            // },
        },
    },
    computed: {
        ...suppliersComputed,
        document_type_options() {
            // need to confirm the details here with api config
            return [
                {
                    value: null,
                    text: "Select an option",
                    disabled: true,
                },
                { value: "Certificate", text: "Certificate" },
                { value: "Affidavit", text: "Affidavit" },
            ];
        },
        vatNoErrorMessage() {
            if (!this.$v.searchForm.vat_no.$dirty) return "";
            if (!this.$v.searchForm.vat_no.conditionalRequired) {
                return "Either a VAT No or Reg No must be provided.";
            }
            if (this.$v.searchForm.vat_no.$error) {
                if (this.$v.searchForm.vat_no.maxLength) {
                    return "VAT No must be 10 digits long.";
                }
                if (this.$v.searchForm.vat_no.$params.numeric) {
                    return "Can only be numbers.";
                }
                return "A Vat No can only be 10 digits long.";
            }
            return "";
        },
        regNoErrorMessage() {
            if (!this.$v.searchForm.company_reg.$dirty) return "";
            if (!this.$v.searchForm.company_reg.conditionalRequired) {
                return "Either a Reg No or Vat no must be provided.";
            }
            if (this.$v.searchForm.company_reg.$error) {
                if (this.$v.searchForm.company_reg.$params.minLength) {
                    return "Reg No must be atleast 3 characters long";
                }
                return "Required";
            }
            return "";
        },
    },
    methods: {
        ...suppliersMethods,
        defaultComponentState() {
            this.searchForm = {
                vat_no: "",
                company_reg: "2010/123456/07",
                document_type: "Certificate",
                issue_date: "2022-05-06",
                expiry_date: "2024-05-06",
                supplier_name: "",
            };
        },
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.searchForm[name];
                return $dirty ? !$error : null;
            }
        },
        search() {
            this.searchForm.supplier_name = this.selected_supplier_details.supplier_name;

            this.formSubmit = true;

            this.$v.searchForm.$touch();
            if (this.$v.searchForm.$anyError) {
                return;
            }

            this.setSearchForCertificatesDetails(this.searchForm);

            this.searchCertificates(this.searchFor_certificates_details).then(() => {
                this.defaultComponentState();

                //if a match was found else go to the add modal
                if (this.result_of_searched_certificates.length > 0) {
                    this.$emit("handleModal", "certificateMatchListModal");
                    this.$bvModal.hide("certificateListModal"); //closes the parent modal
                    this.formSubmit = false;
                    this.closeModal(); // closes this modal
                } else {
                    this.$emit("handleModal", "certificateAddModal");
                    this.$bvModal.hide("certificateListModal"); //closes the parent modal
                    Swal.fire(`No certificate matches found`, "Please manually capture the certificate details", "info");
                    this.formSubmit = false;
                    this.closeModal(); // closes this modal
                }
            });
        },
        closeModal() {
            this.$bvModal.hide("certificateAddSearchModal");
        },
    },
    mounted() {
        this.searchForm.vat_no = this.selected_supplier_details.vat_no;
        this.searchForm.company_reg = this.selected_supplier_details.company_reg;

        this.searchForm.client_id = this.$route.params.client_id;
    },
};
</script>

<style lang="scss" scoped>
.align-text-setting {
    text-align: right;
}
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
}
.not-allowed-pointer {
    cursor: not-allowed;
    user-select: none;
}
</style>
